import { openDB, deleteDB } from 'idb'

const dbPromise = () => {
  if (!('indexedDB' in window)) {
    throw new Error('Browser does not support IndexedDB')
  }

  return openDB("EVE_Fittings", 1, {
    upgrade(db) {
      db.createObjectStore("types", {
        keyPath: "type_id"
      });
      db.createObjectStore("ships", {
        keyPath: "type_id"
      });
      db.createObjectStore("ship_groups", {
        keyPath: "group_id"
      });
      db.createObjectStore("fittings", {
        keyPath: "fitting_id"
      });
      db.createObjectStore("dogma_attributes", {
        keyPath: "attribute_id"
      });
      db.createObjectStore("skills", {
        keyPath: "type_id"
      });
      db.createObjectStore("skill_groups", {
        keyPath: "group_id"
      });
      db.createObjectStore("corporations", {
        keyPath: "corporation_id"
      });
    }
  })
}

const checkStorage = async storeName => {
  try {
    const db = await dbPromise()
    const tx = db.transaction(storeName, 'readonly')
    const store = tx.objectStore(storeName)

    return store.getAll()
  } catch (error) {
    return error
  }
}

const saveToStorage = async (storeName, items) => {
  try {
    const db = await dbPromise()
    const tx = db.transaction(storeName, 'readwrite')
    const store = tx.objectStore(storeName)

    let item_list = [];
    if (Array.isArray(items)) {
      item_list = items;
    } else {
      item_list = Object.values(items);
    }
    item_list.map(x => {
      store.put(x)
    })

    return tx.done
  } catch (error) {
    return error
  }
};

const clearStorage = async () => {
  try {
    return await deleteDB("EVE_Fittings");
  } catch (error) {
    return error;
  }
};

export default {
  checkStorage,
  saveToStorage,
  clearStorage
}
